var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMoon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2311_47243)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.2046 15.8008C11.8648 15.8008 7.81006 11.8282 7.81006 5.47657C7.81006 4.16407 8.12646 2.28907 8.54834 1.31641C8.6538 1.04688 8.67724 0.882812 8.67724 0.765625C8.67724 0.449218 8.44287 0.0976562 7.98584 0.0976562C7.85693 0.0976562 7.57568 0.132812 7.31787 0.226562C2.98193 1.96094 0.0756836 6.625 0.0756836 11.5352C0.0756836 18.4258 5.32568 23.3477 12.1929 23.3477C17.2437 23.3477 21.6148 20.2891 23.0679 16.4688C23.1734 16.1993 23.1968 15.918 23.1968 15.8125C23.1968 15.3789 22.8335 15.086 22.5054 15.086C22.353 15.086 22.2241 15.1211 22.0015 15.1915C21.0991 15.4844 19.646 15.8008 18.2046 15.8008Z",
    fill: "#current",
    fillOpacity: 0.85
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2311_47243"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 23.1211,
    height: 23.2617,
    fill: "white",
    transform: "translate(0.0756836 0.0976562)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoon);
export default __webpack_public_path__ + "static/media/moon.7cefebf587a9a9fb76fce84731b6e68e.svg";
export { ForwardRef as ReactComponent };